/* eslint-disable */

<template>
    <div  class="vx-col ">
      <vx-card class="mb-base">
        <div class="">
          <div :style="{'display': firewall_three === true ? '' : 'none!important'}" class="firewall-popup-block-2" style="background-color: #F8B904">
            <div class="eleventh-block">
              <h1 class="tenth-block-text"><img draggable="false" style="display: inline" src="https://hypertecdirect.com/wp-content/uploads/2015/10/cisco-logo.png" width="30"> Cisco Firepower 2110 Firewall Appliance</h1><img draggable="false"
                                                                                                                                                                                                                               alt="" class="image-49 cursor-pointer-simulation" src="https://rapidsimulations.com/simulations/1/images/cancel.png"
                                                                                                                                                                                                                               width="30" @click="firewall_three = false">
            </div>
            <div class="tenth-line-firewall"></div>
            <div class="tenth-table-block">
              <div class="tenth-table-header-2">
                <div class="tenth-firewall-column w-sim-legacy-row">
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Rule Name</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Source</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Destination</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-2">
                    <p class="tenth-table-title">Service<br></p>
                  </div>
                  <div class="w-sim-legacy-col w-sim-legacy-col-1">
                    <p class="tenth-table-title">Action<br></p>
                  </div>
                </div>
              </div>
              <div class="tenth-table-body">
                <div v-for="answer in firewall_one_answers" :key="answer.id" class="tenth-firewall-column-body w-sim-legacy-row">
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <h5>{{ answer.rule }}</h5>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'threeSource'+answer.id" class="ninth-select w-select">
                      <option v-for="item in source_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'threeDest'+answer.id" class="ninth-select w-select">
                      <option v-for="item in dest_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'threeService'+answer.id" class="ninth-select w-select">
                      <option v-for="item in service_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'threeAction'+answer.id" class="ninth-select w-select">
                      <option v-for="item in action_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :style="{'display': firewall_two === true ? '' : 'none!important'}" class="firewall-popup-block-2" style="background-color: #4169e1">
            <div class="eleventh-block">
              <h1 class="tenth-block-text"><img draggable="false" style="display: inline" src="https://hypertecdirect.com/wp-content/uploads/2015/10/cisco-logo.png" width="30"> Cisco 5516-X NGFW Firewall Appliance</h1><img draggable="false"
                                                                                                                                                                                                                                  alt="" class="image-49 cursor-pointer-simulation" src="https://rapidsimulations.com/simulations/1/images/cancel.png"
                                                                                                                                                                                                                                  width="30" @click="firewall_two = false">
            </div>
            <div class="tenth-line-firewall"></div>
            <div class="tenth-table-block">
              <div class="tenth-table-header-2">
                <div class="tenth-firewall-column w-sim-legacy-row">
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Rule Name</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Source</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Destination</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-2">
                    <p class="tenth-table-title">Service<br></p>
                  </div>
                  <div class="w-sim-legacy-col w-sim-legacy-col-1">
                    <p class="tenth-table-title">Action<br></p>
                  </div>
                </div>
              </div>
              <div class="tenth-table-body">
                <div v-for="answer in firewall_two_answers" :key="answer.id" class="tenth-firewall-column-body w-sim-legacy-row">
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <h5>{{ answer.rule }}</h5>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'twoSource'+answer.id" class="ninth-select w-select">
                      <option v-for="item in source_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'twoDest'+answer.id" class="ninth-select w-select">
                      <option v-for="item in dest_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'twoService'+answer.id" class="ninth-select w-select">
                      <option v-for="item in service_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'twoAction'+answer.id" class="ninth-select w-select">
                      <option v-for="item in action_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :style="{'display': firewall_one === true ? '' : 'none!important'}" class="firewall-popup-block-2" style="background-color: #10ac84 ">
            <div class="eleventh-block">
              <h1 class="tenth-block-text"><img draggable="false" style="display: inline" src="https://hypertecdirect.com/wp-content/uploads/2015/10/cisco-logo.png" width="30"> Cisco Firepower 1140 Firewall Appliance</h1><img draggable="false"
              alt="" class="image-49 cursor-pointer-simulation" src="https://rapidsimulations.com/simulations/1/images/cancel.png"
              width="30" @click="firewall_one = false">
            </div>
            <div class="tenth-line-firewall"></div>
            <div class="tenth-table-block">
              <div class="tenth-table-header-2">
                <div class="tenth-firewall-column w-sim-legacy-row">
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Rule Name</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Source</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <p class="tenth-table-title">Destination</p>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-2">
                    <p class="tenth-table-title">Service<br></p>
                  </div>
                  <div class="w-sim-legacy-col w-sim-legacy-col-1">
                    <p class="tenth-table-title">Action<br></p>
                  </div>
                </div>
              </div>
              <div class="tenth-table-body">
                <div v-for="answer in firewall_one_answers" :key="answer.id" class="tenth-firewall-column-body w-sim-legacy-row">
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <h5>{{ answer.rule }}</h5>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'oneSource'+answer.id" class="ninth-select w-select">
                      <option v-for="item in source_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'oneDest'+answer.id" class="ninth-select w-select">
                      <option v-for="item in dest_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'oneService'+answer.id" class="ninth-select w-select">
                      <option v-for="item in service_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="tenth-firewall-sec w-sim-legacy-col w-sim-legacy-col-3">
                    <select :id="'oneAction'+answer.id" class="ninth-select w-select">
                      <option v-for="item in action_options" :key="item">{{ item }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="simulation-10">
            <div class="columns-13 w-sim-legacy-row">
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3"></div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-public-network-2">
                  <div class="tenth-public-network-bottom-2">
                    <div class="tenth-block">
                      <div class="tenth-image-block"><img draggable="false"
                                                          alt="" class="tenth-image" src="https://psirt.global.sonicwall.com/static/img/logo-symbol.b6899c5.png"
                                                          width="50"></div>
                      <h1 class="tenth-block-text-small">Sonicwall TZ400<br>UTM Router<br>10.10.10.5/26</h1>
                    </div>
                  </div>
                </div>
                <div class="line-router-left"></div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-firewall-block-2 cursor-pointer-simulation" @click="show_firewall('firewall_one')" style="background-color: #10ac84; border-block: medium dashed black; border-width: 0.3em;">
                  <div class="tenth-image-block"><img draggable="false" alt=""
                                                      class="tenth-image" src="https://www.pngrepo.com/png/331335/512/cisco.png" width="60"></div>
                  <h1 class="tenth-internet-text">Cisco Firepower 1140<br>Firewall Appliance</h1>
                </div>
                <div class="firewall-2-line"></div>
              </div>

              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-server">
                  <div class="tenth-public-network-bottom-2">
                    <div class="tenth-block">
                      <div class="tenth-image-block"><img draggable="false"
                                                          alt="" class="tenth-image" src="https://icon-library.com/images/mongodb_1014590.png"
                                                          width="50"></div>
                      <h1 class="tenth-block-text-small">MongoDB NoSQL<br>Database<br>10.10.10.1/26</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="simulation-10">
            <div class="columns-13 w-sim-legacy-row">
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3"></div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-public-network-2">
                    <div class="tenth-public-network-bottom-2">
                      <div class="tenth-block">
                        <div class="tenth-image-block"><img draggable="false"
                                                            alt="" class="tenth-image" src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Dell_logo_2016_black.svg/1024px-Dell_logo_2016_black.svg.png"
                                                            width="50"></div>
                        <h1 class="tenth-block-text-small">Dell N2024<br>Enterprise<br>Primary Switch</h1>
                      </div>
                    </div>
                </div>
                <div class="line-router-left"></div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-firewall-block-2" style="background-color: #341f97">
                  <div class="tenth-image-block"><img draggable="false" alt=""
                                                      class="tenth-image" src="https://www.brighttalk.com/wp-content/uploads/2019/07/fireeye-logo-1.png" width="60"></div>
                  <h1 class="tenth-internet-text">Fireye NX 2500<br>IPS/IDS Applicance</h1>
                </div>
                <div class="firewall-2-line"></div>
              </div>

              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-server">
                  <div class="tenth-public-network-bottom-2">
                    <div class="tenth-block">
                      <div class="tenth-image-block"><img draggable="false"
                        alt="" class="tenth-image" src="https://upload.wikimedia.org/wikipedia/sco/thumb/2/21/Nvidia_logo.svg/1200px-Nvidia_logo.svg.png"
                        width="50"></div>
                      <h1 class="tenth-block-text-small">NVIDIA DGX A100<br>HPC Appliance<br>10.10.10.2/26</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns-13 w-sim-legacy-row">
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-internet-block-2">
                  <div class="tenth-image-block"><img draggable="false" alt=""
                                                      class="tenth-image" src="https://rapidsimulations.com/simulations/1/images/global.png" width="60"></div>
                  <h1 class="tenth-internet-text">Internet</h1>
                </div>
                <div class="line-internet-up"></div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="datacentre-to-wall-2"></div>
                <div class="line-internet-up"></div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-firewall-block-2 cursor-pointer-simulation" @click="show_firewall('firewall_two')" style="background-color: #4169e1; border-block: medium dashed black; border-width: 0.3em;">
                  <div class="tenth-image-block"><img draggable="false" alt=""
                                                      class="tenth-image" src="https://www.pngrepo.com/png/331335/512/cisco.png" width="60"></div>
                  <h1 class="tenth-internet-text">Cisco 5516-X NGFW<br>Firewall Appliance</h1>
                </div>
                <div class="firewall-2-line"></div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-server">
                  <div class="tenth-public-network-bottom-2">
                    <div class="tenth-block">
                      <div class="tenth-image-block"><img draggable="false"
                        alt="" class="tenth-image" src="https://www.westerndigital.com/content/dam/store/en-us/assets/products/desktop/my-cloud-expert-series-ex2-ultra/gallery/mycloud-EX2-Ultra-Hero.png.thumb.319.319.png"
                        width="50"></div>
                      <h1 class="tenth-block-text-small">WD Business NAS<br>File Share<br>10.80.80.1/28</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns-13 w-sim-legacy-row">
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3"></div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="line-router-left"></div>
                <div class="tenth-public-network-bottom-2">
                  <div class="tenth-public-network-2">
                    <div class="tenth-block">
                      <div class="tenth-image-block"><img draggable="false"
                                                          alt="" class="tenth-image"
                                                          src="https://haptx.com/wp-content/uploads/Verizon-Check-1.png"
                                                          width="50"></div>
                      <h1 class="tenth-block-text-small">Verizon FiOS<br>Business Router<br>10.80.80.5/28</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-firewall-block-2 cursor-pointer-simulation" @click="show_firewall('firewall_three')" style="background-color: #F8B904; border-block: medium dashed black; border-width: 0.3em;">
                  <div class="tenth-image-block"><img draggable="false" alt=""
                                                      class="tenth-image" src="https://www.pngrepo.com/png/331335/512/cisco.png" width="60"></div>
                  <h1 class="tenth-internet-text">Cisco Firepower 2110<br>Firewall Appliance</h1>
                </div>
                <div class="firewall-2-line"></div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-server">
                  <div class="tenth-public-network-bottom-2">
                    <div class="tenth-block">
                      <div class="tenth-image-block"><img draggable="false"
                        alt="" class="tenth-image" src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Dell_logo_2016_black.svg/1024px-Dell_logo_2016_black.svg.png"
                        width="50"></div>
                      <h1 class="tenth-block-text-small">Marketing API<br>PowerEdge Server<br>10.80.50.1/28</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns-13 w-sim-legacy-row">
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3"></div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="line-router-left"></div>
                <div class="tenth-public-network-bottom-2">
                  <div class="tenth-public-network-2">
                    <div class="tenth-block">
                      <div class="tenth-image-block"><img draggable="false"
                                                          alt="" class="tenth-image"
                                                          src="https://www.f5.com/content/dam/f5-com/global-assets/default-ogimage.png"
                                                          width="50"></div>
                      <h1 class="tenth-block-text-small">F5 Appliance<br>Load Balancer<br>10.80.80.2/28</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-firewall-block-2" style="background-color: #FD4445">
                  <div class="tenth-image-block"><img draggable="false" alt=""
                                                      class="tenth-image" src="https://cdn.freelogovectors.net/wp-content/uploads/2019/02/ubiquiti_logo.png" width="60"></div>
                  <h1 class="tenth-internet-text">USW XG-24<br>Secondary Switch</h1>
                </div>
                <div class="firewall-2-line"></div>
              </div>
              <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
                <div class="tenth-server">
                  <div class="tenth-public-network-bottom-2">
                    <div class="tenth-block">
                      <div class="tenth-image-block"><img draggable="false"
                                                          alt="" class="tenth-image" src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Microsoft_Office_logo_%282019%E2%80%93present%29.svg/2048px-Microsoft_Office_logo_%282019%E2%80%93present%29.svg.png"
                                                          width="50"></div>
                      <h1 class="tenth-block-text-small">Microsoft o365<br>Mail Backup Server<br>10.80.80.12/28</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
</template>

<script>

import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      firewall_one: false,
      firewall_two: false,
      firewall_three: false,


      current_page: 0,

      source_options: [
        'ANY',
        '10.10.10.1/26',
        '10.80.80.1/28',
        '10.80.50.1/28'
      ],

      dest_options: [
        'ANY',
        '10.10.10.1/26',
        '10.80.80.1/28',
        '10.80.50.1/28'
      ],

      service_options: [
        'ANY',
        'DNS',
        'HTTP',
        'HTTPS',
        'TELNET',
        'SSH'
      ],

      action_options: [
        'PERMIT',
        'DENY'
      ],

      firewall_one_answers: [
        {'id': '1', 'rule': 'DNS Rule', 'source': 'ANY', 'dest': 'ANY', 'service': 'DNS', 'action': 'PERMIT'},
        {
          'id': '2',
          'rule': 'HTTPS EGRESS',
          'source': '10.10.10.1/26',
          'dest': 'ANY',
          'service': 'HTTPS',
          'action': 'PERMIT'
        },
        {'id': '3', 'rule': 'Management', 'source': 'ANY', 'dest': '10.10.10.1/26', 'service': 'SSH', 'action': 'PERMIT'},
        {
          'id': '4',
          'rule': 'HTTPS INGRESS',
          'source': 'ANY',
          'dest': '10.10.10.1/26',
          'service': 'HTTPS',
          'action': 'PERMIT'
        },
        {
          'id': '5', 'rule': 'HTTP INGRESS', 'source': 'ANY', 'dest': '10.10.10.1/26', 'service': 'HTTP', 'action': 'DENY'
        }
      ],


      firewall_two_answers: [
        {'id': '1', 'rule': 'DNS Rule', 'source': 'ANY', 'dest': 'ANY', 'service': 'DNS', 'action': 'PERMIT'},
        {
          'id': '2',
          'rule': 'HTTPS EGRESS',
          'source': '10.80.80.1/28',
          'dest': 'ANY',
          'service': 'HTTPS',
          'action': 'PERMIT'
        },
        {'id': '3', 'rule': 'Management', 'source': 'ANY', 'dest': '10.80.80.1/28', 'service': 'SSH', 'action': 'PERMIT'},
        {
          'id': '4',
          'rule': 'HTTPS INGRESS',
          'source': 'ANY',
          'dest': '10.80.80.1/28',
          'service': 'HTTPS',
          'action': 'PERMIT'
        },
        {'id': '5', 'rule': 'HTTP INGRESS', 'source': 'ANY', 'dest': '10.80.80.1/28', 'service': 'HTTP', 'action': 'DENY'}
      ],

      firewall_three_answers: [
        {'id': '1', 'rule': 'DNS Rule', 'source': 'ANY', 'dest': 'ANY', 'service': 'DNS', 'action': 'PERMIT'},
        {
          'id': '2',
          'rule': 'HTTPS EGRESS',
          'source': '10.80.50.1/28',
          'dest': 'ANY',
          'service': 'HTTPS',
          'action': 'PERMIT'
        },
        {
          'id': '3',
          'rule': 'Management',
          'source': 'ANY',
          'dest': '10.80.50.1/28',
          'service': 'SSH',
          'action': 'PERMIT'
        },
        {
          'id': '4',
          'rule': 'HTTPS INGRESS',
          'source': 'ANY',
          'dest': '10.80.50.1/28',
          'service': 'HTTPS',
          'action': 'PERMIT'
        },
        {
          'id': '5',
          'rule': 'HTTP INGRESS',
          'source': 'ANY',
          'dest': '10.80.50.1/28',
          'service': 'HTTP',
          'action': 'DENY'
        }
      ]


    }
  },
  methods: {
    show_firewall (x) {
      if (x === 'firewall_one') {
        this.firewall_one = true
        this.firewall_two = false
        this.firewall_three = false
      }
      if (x === 'firewall_two') {
        this.firewall_one = false
        this.firewall_two = true
        this.firewall_three = false
      }
      if (x === 'firewall_three') {
        this.firewall_one = false
        this.firewall_two = false
        this.firewall_three = true
      }
    },
    markSimulation () {

      let total_score = 0

      this.firewall_one_answers.forEach(x => {
        if (x.source === document.getElementById(`oneSource${  x.id}`).value) {
          document.getElementById(`oneSource${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`oneSource${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`oneSource${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`oneSource${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.dest === document.getElementById(`oneDest${  x.id}`).value) {
          document.getElementById(`oneDest${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`oneDest${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`oneDest${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`oneDest${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.service === document.getElementById(`oneService${  x.id}`).value) {
          document.getElementById(`oneService${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`oneService${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`oneService${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`oneService${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.action === document.getElementById(`oneAction${  x.id}`).value) {
          document.getElementById(`oneAction${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`oneAction${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`oneAction${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`oneAction${  x.id}`).style.backgroundColor = '#fd4445'
        }
      })

      this.firewall_two_answers.forEach(x => {
        if (x.source === document.getElementById(`twoSource${  x.id}`).value) {
          document.getElementById(`twoSource${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`twoSource${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`twoSource${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`twoSource${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.dest === document.getElementById(`twoDest${  x.id}`).value) {
          document.getElementById(`twoDest${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`twoDest${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`twoDest${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`twoDest${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.service === document.getElementById(`twoService${  x.id}`).value) {
          document.getElementById(`twoService${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`twoService${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`twoService${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`twoService${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.action === document.getElementById(`twoAction${  x.id}`).value) {
          document.getElementById(`twoAction${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`twoAction${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`twoAction${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`twoAction${  x.id}`).style.backgroundColor = '#fd4445'
        }
      })
      this.firewall_three_answers.forEach(x => {
        if (x.source === document.getElementById(`threeSource${  x.id}`).value) {
          document.getElementById(`threeSource${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`threeSource${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`threeSource${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`threeSource${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.dest === document.getElementById(`threeDest${  x.id}`).value) {
          document.getElementById(`threeDest${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`threeDest${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`threeDest${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`threeDest${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.service === document.getElementById(`threeService${  x.id}`).value) {
          document.getElementById(`threeService${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`threeService${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`threeService${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`threeService${  x.id}`).style.backgroundColor = '#fd4445'
        }
        if (x.action === document.getElementById(`threeAction${  x.id}`).value) {
          document.getElementById(`threeAction${  x.id}`).style.borderColor = '#77FAAE'
          document.getElementById(`threeAction${  x.id}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`threeAction${  x.id}`).style.borderColor = '#fd4445'
          document.getElementById(`threeAction${  x.id}`).style.backgroundColor = '#fd4445'
        }
      })

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    Prism
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

<style lang="scss" scoped>

.w-select {
  font-weight: 800;
}

@import "@/views/simulations/legacy/css/CompTIA/Security+/Lgx335106580255080448.scss";

</style>

